<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="5mm" height="5mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
  viewBox="0 0 12457 12457"
   xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Pracovní_x0020_plocha">
    <g id="_674093176">
     <path class="fil0 str0" d="M7475 6994c484,0 879,-395 879,-879l0 -5138c0,-483 -395,-879 -879,-879l-1784 0c-483,0 -879,396 -879,879l0 5138c0,484 396,879 879,879l1784 0z"/>
     <path class="fil0 str0" d="M879 12457c-483,0 -879,-396 -879,-879l0 -10699c0,-483 396,-879 879,-879l2345 0c484,0 879,396 879,879l0 10699c0,483 -395,879 -879,879l-2345 0z"/>
     <path class="fil0 str0" d="M12457 9965c0,-483 0,-1176 0,-1538 0,-363 0,-1056 0,-1539l0 -2198c0,-484 -396,-880 -880,-880l-1612 0c-483,0 -879,396 -879,880l0 2198c0,483 -396,879 -879,879l-2492 0c-483,0 -879,396 -879,879l0 2932c0,483 396,879 879,879l5862 0c484,0 880,-396 880,-879l0 -1613z"/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'Visualization',
};
</script>

<style scoped>
.fil0 {fill:#666666;fill-rule:nonzero}
.str0 {stroke:#666666;stroke-width:100}
</style>
